/* Banner nativo de Shopify: sustituye el texto legal genérico por la voz
   de FOCUS y deja un solo clic claro (Aceptar). El permiso lo sigue
   registrando el botón nativo; aquí solo se cambia lo que se lee.
   Shopify lo inyecta tarde y a veces lo vuelve a pintar. Se espera a que
   aparezca el propio banner (sin vigilar toda la página) y luego se
   vigila solo ese bloque unos segundos.

   El banner iba fijo al borde inferior y tapaba la barra de comprar. Se
   mide esa barra (portada .fe-bc, ficha .fe-barra / .v2-barra) y se deja
   el cartel justo encima, sin tapar el botón. */
(function () {
  var TITULO = 'Usamos cookies para que todo funcione';
  var CUERPO = 'Cargan la tienda, recuerdan tu carrito y mejoran FOCUS. ';
  var POLITICA = 'Política de privacidad';
  var BOTONES = {
    'shopify-pc__banner__btn-accept': 'Aceptar',
    'shopify-pc__banner__btn-manage-prefs': 'Ajustar'
  };
  var BARRAS = ['.fe-barra', '.fe-bc', '.v2-barra'];
  var BARRAS_VISIBLES = ['.fe-barra--visible', '.fe-bc--visible', '.v2-barra--visible'];
  var html = document.documentElement;
  var huecoRaf = 0;

  function textoDe(nodo) {
    return nodo ? String(nodo.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function ponerTexto(nodo, valor) {
    if (!nodo || textoDe(nodo) === valor) return;
    nodo.textContent = valor;
  }

  function reescribirCuerpo(banner) {
    var parrafo = banner.querySelector('.shopify-pc__banner__body p');
    if (!parrafo) return;
    var enlace = document.getElementById('shopify-pc__banner__body-policy-link') ||
      parrafo.querySelector('a');
    var yaListo = parrafo.firstChild &&
      parrafo.firstChild.nodeType === 3 &&
      parrafo.firstChild.textContent === CUERPO &&
      enlace && textoDe(enlace) === POLITICA;
    if (yaListo) return;

    while (parrafo.firstChild) parrafo.removeChild(parrafo.firstChild);
    parrafo.appendChild(document.createTextNode(CUERPO));
    if (enlace) {
      enlace.textContent = POLITICA;
      parrafo.appendChild(enlace);
    }
  }

  function bannerMontado(banner) {
    if (!banner || banner.hidden) return false;
    var estilo = window.getComputedStyle(banner);
    if (estilo.display === 'none' || estilo.visibility === 'hidden') return false;
    return banner.getBoundingClientRect().height > 8;
  }

  function alturaCompra() {
    var maximo = 0;
    for (var i = 0; i < BARRAS_VISIBLES.length; i++) {
      var barra = document.querySelector(BARRAS_VISIBLES[i]);
      if (!barra) continue;
      var alto = barra.offsetHeight;
      if (alto < 8) continue;
      var caja = barra.getBoundingClientRect();
      var desdeAbajo = Math.ceil(window.innerHeight - caja.top);
      // La barra entra con transform: el rectángulo aún está fuera.
      // offsetHeight es el sitio final, pegada al borde inferior.
      if (desdeAbajo < alto) desdeAbajo = alto;
      if (desdeAbajo > maximo) maximo = desdeAbajo;
    }
    return maximo;
  }

  function sincronizarHueco() {
    var banner = document.getElementById('shopify-pc__banner');
    var visible = bannerMontado(banner);
    var compra = alturaCompra();
    var altoBanner = visible ? Math.ceil(banner.getBoundingClientRect().height) : 0;
    html.style.setProperty('--fe-compra-sticky-h', compra + 'px');
    html.style.setProperty('--fe-pc-banner-h', altoBanner + 'px');
    if (visible) html.setAttribute('data-fe-pc-banner', '1');
    else html.removeAttribute('data-fe-pc-banner');
  }

  function pedirHueco() {
    if (huecoRaf) return;
    huecoRaf = window.requestAnimationFrame(function () {
      huecoRaf = 0;
      sincronizarHueco();
    });
  }

  function observarBarras() {
    for (var i = 0; i < BARRAS.length; i++) {
      var barra = document.querySelector(BARRAS[i]);
      if (!barra || barra.getAttribute('data-fe-hueco') === '1') continue;
      barra.setAttribute('data-fe-hueco', '1');
      new MutationObserver(function () {
        pedirHueco();
        setTimeout(pedirHueco, 80);
        setTimeout(pedirHueco, 450);
      }).observe(barra, {
        attributes: true,
        attributeFilter: ['class']
      });
      barra.addEventListener('transitionend', pedirHueco);
    }
  }

  function vigilarHueco(banner) {
    if (!banner || banner.getAttribute('data-fe-hueco-banner') === '1') return;
    banner.setAttribute('data-fe-hueco-banner', '1');
    new MutationObserver(pedirHueco).observe(banner, {
      attributes: true,
      childList: true,
      subtree: true
    });
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(pedirHueco).observe(banner);
    }
    if (banner.parentNode) {
      new MutationObserver(function () {
        if (!document.getElementById('shopify-pc__banner')) pedirHueco();
      }).observe(banner.parentNode, { childList: true });
    }
    observarBarras();
    pedirHueco();
  }

  function aplicar() {
    var banner = document.getElementById('shopify-pc__banner');
    var titulo = document.getElementById('shopify-pc__banner__body-title');
    if (!banner || !titulo) return false;

    ponerTexto(titulo, TITULO);
    reescribirCuerpo(banner);

    Object.keys(BOTONES).forEach(function (id) {
      ponerTexto(document.getElementById(id), BOTONES[id]);
    });

    if (!banner.classList.contains('fe-cookies-listo')) {
      banner.classList.add('fe-cookies-listo');
    }
    vigilarHueco(banner);
    return true;
  }

  function vigilarBanner(banner) {
    if (!banner || banner.getAttribute('data-fe-cookies') === '1') return;
    banner.setAttribute('data-fe-cookies', '1');
    var obs = new MutationObserver(function () {
      aplicar();
    });
    obs.observe(banner, { childList: true, subtree: true, characterData: true });
    setTimeout(function () {
      obs.disconnect();
    }, 8000);
  }

  function arrancar() {
    if (!aplicar()) return false;
    vigilarBanner(document.getElementById('shopify-pc__banner'));
    return true;
  }

  window.addEventListener('resize', pedirHueco);
  window.addEventListener('scroll', pedirHueco, { passive: true });
  document.addEventListener('click', function (evento) {
    var destino = evento.target && evento.target.closest
      ? evento.target.closest(
        '#shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline, #shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-decline, #shopify-pc__prefs__header-save'
      )
      : null;
    if (!destino) return;
    setTimeout(pedirHueco, 50);
    setTimeout(pedirHueco, 400);
  }, true);

  if (arrancar()) return;

  var busca = new MutationObserver(function () {
    observarBarras();
    if (arrancar()) busca.disconnect();
  });
  busca.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    busca.disconnect();
    arrancar();
    observarBarras();
    pedirHueco();
  }, 20000);
})();
